import * as React from 'react';
import { WithGroup, WithGroupProps } from '../Context';
import { InjectedTranslateProps, translate } from 'react-i18next';
import styles from './MembersCount.st.css';
import { Group } from '@wix/social-groups-api';
import { compose } from '@wix/social-groups-common/dist/src/compose';
import { Text } from 'wix-ui-tpa/Text';
import { getMembersLabelWithCount } from '../../MembersLabel/MembersLabelWithCount';

export const MEMBERS_COUNT = 'members-count';

const MembersCountComponent: React.FC<WithGroupProps &
  InjectedTranslateProps> = ({ t, group, ...rest }) => {
  const groupWrapper = Group.getGroupResponseWrapper(group);
  const membersCount = groupWrapper.getMembersCount();
  const membersLabel = groupWrapper.getMembersName();
  const label = getMembersLabelWithCount(membersLabel, membersCount, t);
  return (
    <Text data-hook={MEMBERS_COUNT} {...styles(styles.root, {}, rest)}>
      {label}
    </Text>
  );
};

const enhance = compose(translate(), WithGroup);
export const MembersCount = enhance(MembersCountComponent);
